import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ProductCategorySideBar from "../../Components/RecentArticles/RecentArticles";
import "./Article.css";
import { FaRegCommentDots } from "react-icons/fa";
import ArticleSliderItem from "../../Components/ArticleSliderItem/ArticleSliderItem";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import { useNavigate, useParams } from "react-router-dom";
import { BsBookmark, BsFillBookmarkFill } from "react-icons/bs";
import { AiFillHeart, AiOutlineEye, AiOutlineHeart } from "react-icons/ai";
import ImageNotFound from "../../Assets/images/ImageNotFound.jpg";
import UserComment from "../../Components/UserComment/UserComment";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

function Article() {
    const param = useParams("title");
    const nav = useNavigate();
    const [blog, setBlog] = useState({
        title: "",
        id: "",
        image: "",
        text: "",
        blogSaves: [],
        blogVisits: [],
        isLiked: false,
        isSaved: false,
        commentCount: 0,
        blogLikes: [],
    });
    const [blogList, setBlogList] = useState([]);
    useEffect(() => {
        axiosConfig
            .get(
                "api/blog/details/" +
                encodeURIComponent(param.title) +
                "?userId=" +
                localStorage.getItem("userId")
            )
            .then((result) => {
                setBlog(result.data);
                axiosConfig
                    .post("api/Blog/blogVisit/" + result.data.id)
                    .then((res) => { });
            });

        axiosConfig
            .get("api/blog?page=1&pageSize=4&orderBy=RegisterDate")
            .then((result) => {
                setBlogList(result.data.data);
            });
    }, [param]);
    function saveArticle() {
        axiosConfig
            .post("api/Blog/blogSave/" + blog.id)
            .then((result) => {
                toast.success("با موفقیت وبلاگ سیو شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setBlog({ ...blog, isSaved: true });
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    function deleteSaveArticle() {
        axiosConfig
            .delete("api/Blog/deleteblogSave/" + blog.id)
            .then((result) => {
                toast.success("با موفقیت وبلاگ سیو شده حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setBlog({ ...blog, isSaved: false });
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }

    function likeArticle() {
        axiosConfig
            .post("api/Blog/blogLike/" + blog.id)
            .then((result) => {
                toast.success("با موفقیت وبلاگ پسندیده شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setBlog({
                    ...blog,
                    isLiked: true,
                    blogLikes: [
                        ...blog.blogLikes,
                        {
                            id: "ss",
                        },
                    ],
                });
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    function deleteLikeArticle() {
        axiosConfig
            .delete("api/Blog/deleteblogLike/" + blog.id)
            .then((result) => {
                toast.success("با موفقیت برداشته شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setBlog({
                    ...blog,
                    isLiked: false,
                    blogLikes: blog.blogLikes.splice(1, 1),
                });
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }

    return (
        <>
            <Helmet>
            <title>سه نیک | {blog.title.slice(0,54)}</title>
                <meta
                    name="description"
                    content={blog.summary?.slice(0,160) || 'مشاهده جزئیات '}
                />
            </Helmet>
            <div className="article">
                <Container>
                    <Row>
                        <Col lg={9}>
                            <div className="article-right">
                                <div className="article-header">
                                    <h1>{blog.title}</h1>
                                </div>
                                <div className="article-information">
                                    <div className="article-information-right">
                                        <div className="article-information-right-icon">
                                            <FaRegCommentDots />
                                            {blog.commentCount} کامنت
                                        </div>
                                        <div className="article-information-right-view">
                                            <AiOutlineEye />
                                            {blog.blogVisits.length + "   "}
                                            بازدید
                                        </div>
                                    </div>
                                    <div className="article-information-left">
                                        {blog.isSaved == true ? (
                                            <BsFillBookmarkFill
                                                onClick={deleteSaveArticle}
                                            />
                                        ) : (
                                            <BsBookmark onClick={saveArticle} />
                                        )}

                                        <div className="article-information-left-like">
                                            {blog.blogLikes.length + "  "}
                                            {blog.isLiked == true ? (
                                                <AiFillHeart
                                                    onClick={deleteLikeArticle}
                                                />
                                            ) : (
                                                <AiOutlineHeart
                                                    onClick={likeArticle}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="article-content">
                                {blog.image != null ? (
                                    <img
                                        src={
                                            axiosConfig.defaults.baseURL +
                                            "Images/BlogImage/" +
                                            blog.id +
                                            "/" +
                                            blog.image
                                        }
                                        alt={blog.title}
                                    />
                                ) : (
                                    <img src={ImageNotFound} alt={blog.title} />
                                )}

                                <div
                                    className="mt-20 article-paragraph"
                                    dangerouslySetInnerHTML={{
                                        __html: blog.summary,
                                    }}
                                />
                            </div>
                            <UserComment itemId={blog.id} />
                        </Col>
                        <Col lg={3}>
                            <div className="article-left">
                                <ProductCategorySideBar />
                            </div>
                        </Col>
                    </Row>
                    <div className="Other-articles">
                        <div className="Other-articles-title">
                            <h1>مقالات بیشتر</h1>
                        </div>
                        <Row>
                            {blogList?.map((item) => (
                                <Col lg={3} key={item.id}>
                                    <ArticleSliderItem item={item} />
                                </Col>
                            ))}
                        </Row>
                    </div>
                    <div className="Other-articles-responsive">
                        <Swiper
                            slidesPerView={2}
                            spaceBetween={10}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                300: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 20,
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 40,
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 40,
                                },
                            }}
                            modules={[Autoplay]}
                            className="mySwiper"
                        >
                            {blogList?.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <ArticleSliderItem item={item} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </Container>
            </div>
        </>
    );
}
export default memo(Article);
